import React from 'react';
import { Button } from '../components/ui/button';
import {
  Tabs, TabsContent, TabsList, TabsTrigger,
} from '../components/ui/tabs';
import { FileArrowDown, CloudArrowUp } from '@phosphor-icons/react';
import { useOdmConfig } from './odm-config/useOdmConfig';
import ProviderConfigCard from './odm-config/ProviderConfigCard';
import {
  PlaceOfServiceTab,
  DiagnosisCodesTab,
  ManagedCarePayersTab,
} from './odm-config/ReferenceDataTabs';
import PendingClaimsTab from './odm-config/PendingClaimsTab';

const ODMConfigPage = () => {
  const {
    odmConfig,
    claims,
    loading,
    selectedClaims,
    exporting,
    handleExport837P,
    handleExportPNM,
    handleMarkSubmitted,
    toggleAllClaims,
    toggleClaim,
  } = useOdmConfig();

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="w-8 h-8 border-4 border-indigo-900 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  return (
    <div className="space-y-6 animate-fade-in" data-testid="odm-config-page">
      {/* Header */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <div>
          <h1
            className="text-3xl font-bold text-slate-900"
            style={{ fontFamily: 'Manrope' }}
          >
            ODM Claims
          </h1>
          <p className="text-slate-500 mt-1">
            Ohio Department of Medicaid - 837P Professional Claims
          </p>
        </div>
        <div className="flex gap-3">
          <Button
            variant="outline"
            onClick={handleExportPNM}
            disabled={exporting || claims.length === 0}
            data-testid="export-pnm-btn"
          >
            <FileArrowDown size={18} className="mr-2" />
            Export for PNM Portal
          </Button>
          <Button
            className="bg-indigo-900 hover:bg-indigo-800"
            onClick={handleExport837P}
            disabled={exporting || claims.length === 0}
            data-testid="export-837p-btn"
          >
            <CloudArrowUp size={18} className="mr-2" />
            Generate 837P EDI
          </Button>
        </div>
      </div>

      <ProviderConfigCard billingProvider={odmConfig?.billing_provider} />

      <Tabs defaultValue="pos" className="space-y-4">
        <TabsList className="grid w-full grid-cols-4">
          <TabsTrigger value="pos">Place of Service</TabsTrigger>
          <TabsTrigger value="diagnosis">Diagnosis Codes</TabsTrigger>
          <TabsTrigger value="payers">Managed Care Payers</TabsTrigger>
          <TabsTrigger value="claims">Pending Claims</TabsTrigger>
        </TabsList>
        <TabsContent value="pos">
          <PlaceOfServiceTab codes={odmConfig?.place_of_service_codes} />
        </TabsContent>
        <TabsContent value="diagnosis">
          <DiagnosisCodesTab codes={odmConfig?.diagnosis_codes} />
        </TabsContent>
        <TabsContent value="payers">
          <ManagedCarePayersTab
            payers={odmConfig?.managed_care_payers}
            odmFfsPayerId={odmConfig?.odm_ffs_payer_id}
          />
        </TabsContent>
        <TabsContent value="claims">
          <PendingClaimsTab
            claims={claims}
            selectedClaims={selectedClaims}
            onToggleAll={toggleAllClaims}
            onToggle={toggleClaim}
            onMarkSubmitted={handleMarkSubmitted}
          />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default ODMConfigPage;
